// extracted by mini-css-extract-plugin
module.exports = {"benefits":"pc_benefits__oyP9l","benefitsLocal":"pc_benefitsLocal__s30Lc"};